import React from 'react';
import { showTopLevelNavigation } from 'global-config';
import TabsMenuView from './tabs_menu_view';

const { VCSTATE } = window;

const tabs = VCSTATE.SITE_NAV_SECTIONS.map(({
  image_class: className,
  name: label,
  url,
  dimension_product_id: dimensionId,
  rollout_feature: feature,
}) => ({
  className,
  label,
  url,
  dimensionId,
  feature,
}));

export default () => (
  showTopLevelNavigation && <TabsMenuView tabs={tabs} />
);
